import React, { useState } from "react";
import "../css/Login.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import Logo from "../assets/img/ThinkStore_Logo.png";

const SendEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendEmail = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
        { email }
      );

      const data = response.data;

      showSuccessToast(data.message || TOAST_MESSAGES.AUTH.RESET_CODE_SENT);
      sessionStorage.setItem("resetEmail", email);
      navigate("/verify-email");
    } catch (err) {
      const errorMsg =
        err.response?.data?.message || TOAST_MESSAGES.AUTH.RESET_EMAIL_FAILED;
      showErrorToast(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container d-flex">
      {/* Left Panel */}
      <div className="login-left"></div>

      {/* Right Panel */}
      <div className="login-right d-flex flex-column align-items-start justify-content-center">
        {/* Fixed Logo */}
        <div className="mx-auto">
          <img
            src={Logo}
            className="w-80 aspect-[4/1] object-contain"
            alt="Logo"
          />
        </div>

        <form
          className="login-form p-4 bg-white rounded-3 mt-3 mx-auto"
          onSubmit={handleSendEmail}
          style={{ maxWidth: "420px", width: "100%" }}
        >
          <h3 className="mb-3 text-center fw-bolder">Forgot Password</h3>
          <p className="text-center login-p mx-3 text-muted">
            We will send you a code to reset your password.
          </p>

          <div className="custom-search-wrapper w-100 mb-3">
            <div className="input-group custom-search-group">
              <span className="input-group-text">
                <i className="bi bi-envelope-fill"></i>
              </span>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn custom-btn w-100"
            disabled={loading}
          >
            {loading ? "Sending..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SendEmail;
